// extracted by mini-css-extract-plugin
module.exports = {"pagination":"styles_pagination___26pa","page-number":"styles_page-number__zypMS","active":"styles_active__7RveA","arrow":"styles_arrow__ldiBa"};